import { useTranslation } from 'next-i18next'

import env from '@/lib/env'

export const useMeta = (): PageMeta => {
  const { t } = useTranslation('compliance')

  return {
    title: t('meta.title'),
    description: t('meta.description'),
    og: {
      title: t('meta.og.title'),
      description: t('meta.og.description'),
      image: {
        url: `${env.APP_URL}${t('meta.og.image.url')}`,
      },
    },
  }
}
